import { mstInterface } from 'api-interface/mst.interface';

export class MstConsultantModel implements mstInterface.consultant.GetRes {

    /** 窓口担当者メールアドレス */
    consultantMail: string;
    /** 窓口担当者名 */
    consultantName: string;
}


// WEBPACK FOOTER //
// E:/02_workspace/TenneT/git/tennet_suggestion_box/client/src/app/model/mst.consultant.model.ts